export class ServiceUrlConstants {
  public static readonly PATH_VAR_DOC_TYPE: string = '{doc_type}'
  public static readonly PATH_VAR_REFERENCE_TYPE: string = '{referenceType}'
  public static readonly VAR_REFERENCE_ID: string = 'referenceId'
  public static readonly PATH_VAR_COMPANY_GROUP_ID: string = '{companyGroupId}'
  public static readonly PATH_VAR_TYPE_ACTIVITY_ID: string = '{activityId}'

  public static readonly API_LOGIN: string = '/login'
  public static readonly API_SSO_LOGIN: string = '/sso'
  public static readonly API_GENERATE_OTP_FOR_LOGIN = '/auth/login/otp/generate'
  public static readonly API_OTP_BASED_LOGIN: string = '/login/otp'
  public static readonly API_AUTH_LOGIN_FOR_DISCOVERY = '/auth/login/discovery'

  public static readonly API_LOGOUT: string = '/logout'
  public static readonly API_FORGOT_PASSWORD: string = '/password/forgot'

  public static readonly API_SESSION_REFRESH: string = '/token/refresh'
  public static readonly API_ACTVITY_DASHBOARD: string = '/module/ACTIVITY/dashboard'
  public static readonly API_SAVE_ACTIVITY: string = '/activity'
  public static readonly API_DOCUMENT: string = '/document/{doc_type}/reference/{referenceType}'
  public static readonly API_INITIALISE: string = '/initialise'
  public static readonly API_COMPANY_SETTINGS: string = '/company/{companyGroupId}/settings'
  public static readonly API_QUERIES_DASHBOARD: string = '/module/QUERIES/dashboard'
  public static readonly API_SAVE_QUERY: string = '/queries'
  public static readonly API_EMPLOYEE_PERSONAL_INFO: string = '/user/details'
  public static readonly API_EMPLOYEE_REFERENCE_DETAILS: string = '/employee/reference-details'
  public static readonly API_OPTIONS: string = '/options'
  public static readonly API_DASHBOARD: string = '/dashboard'

  public static readonly API_RESET_WITH_PASSWORD = '/password/reset/PASSWORD'
  public static readonly API_FETCH_ACTIVITY_DETAILS: string = '/activity/'
  public static readonly API_UPDATE_ACTIVITY: string = '/activity/'
  public static readonly PATH_VAR_TYPE_ID: string = '{typeId}'
  public static readonly PATH_VAR_TYPE: string = '{type}'
  public static readonly API_EXPORT_PDF: string = `/export/pdf/${ServiceUrlConstants.PATH_VAR_TYPE}/${ServiceUrlConstants.PATH_VAR_TYPE_ID}`

  public static readonly API_FETCH_QUERY_DETAILS: string = '/queries/'
  public static readonly API_UPDATE_QUERY: string = '/queries/'

  public static readonly API_SAVE_KNOWLEDGE: string = '/knowledgeArticle'
  public static readonly API_VIEW_KNOWLEDGE: string = '/knowledgeArticle/'
  public static readonly API_VIEW_KNOWLEDGE_SEARCH_LIST: string = '/knowledgeArticle/list'
  public static readonly API_EMPLOYEE_GENERATE_FORM11_READ_UPLOAD: string = '/employee/generate/form11/read-and-upload'
  public static readonly API_UPDATE_REFERENCE_DETAILS: string = '/employee/reference-details'
  public static readonly API_DOWNLOAD_FORM11: string = '/download/form11'
  public static readonly API_DOWNLOAD_DELETE_DOCUMENT: string = '/document/'
  public static readonly API_UPLOAD_FORM11: string = '/uploadForm11Document/{activityId}'
  public static readonly API_SAVE_FEEDBACK: string = '/feedBack'
  public static readonly API_EXPORT: string = '/export/'
  public static readonly API_SUMMARY_LIST = '/summary/list'
  public static readonly API_ACTIVITY_SUMMARY_LIST = `${ServiceUrlConstants.API_SAVE_ACTIVITY}${ServiceUrlConstants.API_SUMMARY_LIST}`
  public static readonly API_QUERY_LIST: string = '/queries/list'

  public static readonly API_FETCH_QUESTIONS_FROM_TEMPLATE: string = '/feedback/template'
  public static readonly API_SAVE_FEEDBACK_RESPONSE = '/feedback/response'
  public static readonly API_UPDATE_FEEDBACK_STATUS = '/feedback/status'
  public static readonly API_CUSTOM_MESSAGE = '/custom-message/'

  public static createUploadDocumentEndpoint(docType: string, referenceType: string, referenceId?: string) {
    return `${ServiceUrlConstants.API_DOCUMENT.replace(ServiceUrlConstants.PATH_VAR_DOC_TYPE, docType).replace(
      ServiceUrlConstants.PATH_VAR_REFERENCE_TYPE,
      referenceType
    )}${referenceId ? `?${ServiceUrlConstants.VAR_REFERENCE_ID}=${referenceId}` : ''}`
  }

  public static createDownloadExportPDFEndpoint(referenceType: string, referenceId: string) {
    return `${ServiceUrlConstants.API_EXPORT_PDF.replace(ServiceUrlConstants.PATH_VAR_TYPE, referenceType).replace(
      ServiceUrlConstants.PATH_VAR_TYPE_ID,
      referenceId
    )}`
  }

  public static createCompanySettingsEndpoint(groupId: string) {
    return `${ServiceUrlConstants.API_COMPANY_SETTINGS.replace(ServiceUrlConstants.PATH_VAR_COMPANY_GROUP_ID, groupId)}`
  }

  public static createDeleteDocumentEndpoint(
    referenceType: string,
    docType: string,
    documentId: string,
    documentName: string
  ) {
    return `${ServiceUrlConstants.API_DOCUMENT.replace(ServiceUrlConstants.PATH_VAR_DOC_TYPE, docType).replace(
      ServiceUrlConstants.PATH_VAR_REFERENCE_TYPE,
      referenceType
    )}?documentId=${documentId}&documentName=${documentName}`
  }

  public static createDownloadDocumentEndpoint(companyId: string, ownerId: string, name: string) {
    return `/document/${companyId}/${ownerId}/${name}`
  }

  public static createDownloadAllDocumentsEndpoint(referenceId: string) {
    return `/document/${referenceId}/all`
  }
}
